import { styled } from 'shared/ui';

export const SysDiaWrap = styled('div', {
  display: 'flex',
  gap: '24px',
  minWidth: 0,
  width: '100%',
});
